import {Routes} from "@angular/router";


//Patient components
import {InitialQuestionnaireComponent} from "./views/patients/initial-questionnaire.component";
import {InitialExamComponent} from "./views/patients/initial-exam.component";
import {FollowupExamComponent} from "./views/patients/followup-exam.component";
import {ResultsReviewComponent} from "./views/patients/results-review.component";
import {LabOrderComponent} from "./views/patients/lab-order.component";
import {ExposureCalendarComponent} from "./views/patients/exposure-calendar.component";
import {PatientCreateComponent} from "./views/patients/create.component";
import {PatientComponent} from "./views/patients/list.component";
//Provider components
import {ProviderRegistrationComponent} from "./views/provider/provider-registration.component";
import {ProviderApprovalComponent} from "./views/provider/provider-approval.component";
import {ProviderPreferencesComponent} from "./views/provider/provider-preferences.component";
import {ProviderComponent} from "./views/provider/list.component";
//Employer
import {EmployerRegistrationComponent} from "./views/employer/registration.component";
import {EmployerComponent} from "./views/employer/list.component";
//DPR
import {DownloadComponent} from "./views/dpr/download.component";
import {ConfirmationComponent} from "./views/dpr/confirmation.component";
//Audit
import {AuditComponent} from "./views/audit/audit.component";

import {StarterViewComponent} from "./views/appviews/starterview.component";
import {LoginComponent} from "./views/appviews/login.component";

import {BlankLayoutComponent} from "./components/common/layouts/blankLayout.component";
import {BasicLayoutComponent} from "./components/common/layouts/basicLayout.component";
import {TopNavigationLayoutComponent} from "./components/common/layouts/topNavigationLayout.component";

export const ROUTES:Routes = [
  // Main redirect
  {path: '', redirectTo: 'starterview', pathMatch: 'full'},
  {
    path: 'patients', component: BasicLayoutComponent,
    children: [
      {path: 'initial-questionnaire', component: InitialQuestionnaireComponent},
      {path: 'initial', component: InitialExamComponent},
      {path: 'followup', component: FollowupExamComponent},
      {path: 'results-review', component: ResultsReviewComponent},
      {path: 'lab-order', component: LabOrderComponent},
      {path: 'exposure-calendar', component: ExposureCalendarComponent},
      {path: 'create', component: PatientCreateComponent},
      {path: '', component: PatientComponent}
    ]
  },
  {
    path: 'providers', component: BasicLayoutComponent,
    children: [
      {path: 'registration', component: ProviderRegistrationComponent},
      {path: 'approval', component: ProviderApprovalComponent},
      {path: 'preferences', component: ProviderPreferencesComponent},
      {path: '', component: ProviderComponent}
    ]
  },
  {
    path: 'employer', component: BasicLayoutComponent,
    children: [
      {path: 'registration', component: EmployerRegistrationComponent},
      {path: '', component: EmployerComponent}
    ]
  },
  {
    path: 'dpr', component: BasicLayoutComponent,
    children: [
      {path: 'download', component: DownloadComponent},
      {path: 'code', component: ConfirmationComponent}
    ]
  },
  {
    path: 'audit', component: BasicLayoutComponent,
    children: [
      {path: '', component: AuditComponent}
    ]
  },
  {
    path: '', component: BlankLayoutComponent,
    children: [
      {path: 'starterview', component: LoginComponent }
    ]
  },

  // Handle all other routes
  {path: '**',  redirectTo: 'starterview'}
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts